import React, { useEffect, useState,useRef } from "react";
import AxiosInstance from '../AxiosInstance';
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { FaTrash } from 'react-icons/fa';
import Pagination from "../Pagination";
import ToastNotification from "../ToastNotification";

const EmployeeList = () => {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const toastRef = useRef(null); // Create a ref for the toast
  const filteredEmployees = employees.filter((employee) =>
    `${employee.first_name} ${employee.last_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
  // Fetch employees
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await AxiosInstance.get(`/admin/employees?page=${currentPage}&search=${searchTerm}`);
        setEmployees(response.data.employees);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        const message = error.response?.data?.error || "Failed to fetch employees.";
        toastRef.current?.showToast(message, "danger");
      }
    };
    fetchEmployees();
  }, [currentPage, searchTerm]);

  // Delete employee
  const deleteEmployee = async (user_id) => {
    try {
      const response = await AxiosInstance.delete(`/admin/deleteEmployee/${user_id}`);
      if (response.data === "Employee deleted successfully") {
        setEmployees(employees.filter((employee) => employee.user_id !== user_id));
        toastRef.current?.showToast("Employee deleted successfully.", "success");
      } else {
        toastRef.current?.showToast("Unexpected response. Try again.", "danger");
      }
    } catch (error) {
      const message = error.response?.data?.error || "Error deleting employee.";
      toastRef.current?.showToast(message, "danger");
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  return (
    <Layout heading="Employees">
        <div className="container d-flex flex-column flex-grow-1">
          {/* Search + Button */}
          <div className="row mb-3 align-items-center justify-content-between">
            <div className="col-12 col-sm-8 col-md-6 col-lg-4 mb-2 mb-sm-0">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search text-secondary"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search employees..."
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
            </div>
            <div className="col-12 col-sm-4 col-md-6 col-lg-2 d-flex justify-content-end">
              <button
                className="btn btn-primary w-100 w-sm-auto"
                onClick={() => navigate("/add-employee")}
              >
                <i className="bi bi-plus"></i> Add Employee
              </button>
            </div>
          </div>

          <div className="d-block d-md-none" style={{ overflowY: "auto", height: "300px" }}>
            <div className="table-responsive">
              <table className="table table-hover table-striped text-center align-middle">
                <thead className="table-primary">
                  <tr>
                    <th>#</th>
                    <th className="text-start">Employee Code</th>
                    <th className="text-start">Employee Name</th>
                    <th className="text-start">Department</th>
                    <th className="text-start ">Contact Number</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEmployees.length > 0 ? (
                    filteredEmployees.map((employee, index) => (
                      <tr
                        key={employee.user_id}
                        className={employee.status_id === 6 ? "table-danger" : ""}
                      >
                        <td>{(currentPage - 1) * 10 + index + 1}</td>
                        <td className="text-start">{employee.employee_code || "N/A"}</td>
                        <td
                          className="text-start"
                          onClick={() => navigate("/employeedetails", {
                            state: { user_id: employee.user_id },
                          })}
                          style={{ cursor: "pointer" }}
                        >
                          {`${employee.first_name} ${employee.last_name}`.replace(/\b\w/g, char => char.toUpperCase())}
                        </td>
                        <td className="text-start ">{employee.department_name || "N/A"}</td>
                        <td className="text-start ">{employee.phone_number || "N/A"}</td>
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteEmployee(employee.user_id)}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-muted">No employees found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="d-none d-md-block">
            <div className="table-responsive">
              <table className="table table-hover table-striped text-center align-middle">
                <thead className="table-primary">
                  <tr>
                    <th>#</th>
                    <th className="text-start">Employee Code</th>
                    <th className="text-start">Employee Name</th>
                    <th className="text-start d-none d-md-table-cell">Department</th>
                    <th className="text-start d-none d-lg-table-cell">Contact Number</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEmployees.length > 0 ? (
                    filteredEmployees.map((employee, index) => (
                      <tr
                        key={employee.user_id}
                        className={employee.status_id === 6 ? "table-danger" : ""}
                      >
                        <td>{(currentPage - 1) * 10 + index + 1}</td>
                        <td className="text-start">{employee.employee_code || "N/A"}</td>
                        <td
                          className="text-start"
                          onClick={() => navigate("/employeedetails", {
                            state: { user_id: employee.user_id },
                          })}
                          style={{ cursor: "pointer" }}
                        >
                          {`${employee.first_name} ${employee.last_name}`.replace(/\b\w/g, char => char.toUpperCase())}
                        </td>
                        <td className="text-start d-none d-md-table-cell">{employee.department_name || "N/A"}</td>
                        <td className="text-start d-none d-lg-table-cell">{employee.phone_number || "N/A"}</td>
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteEmployee(employee.user_id)}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-muted">No employees found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* Pagination stays visible! */}
          <div className="row mt-2 mb-3">
            <div className="col d-flex justify-content-center">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
        </div>
        <ToastNotification ref={toastRef} />
    </Layout>

  );
};

export default EmployeeList;
